package uz.mint.frontend.pages.uz

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.LegalPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.faqFor
import uz.mint.frontend.i18n.stringsFor
import uz.mint.frontend.seo.IndexablePage

private val LOCALE = Locale.UZ

@InitRoute
fun initUzbekFaqPage(ctx: InitRouteContext) {
    val strings = stringsFor(LOCALE)
    ctx.data.add(
        PageLayoutData(
            strings.faqTitle + " — Mint.uz",
            LOCALE,
            strings.faqMetaDescription,
            page = IndexablePage.FAQ,
        )
    )
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun UzbekFaqPage() {
    LegalPage(LOCALE, stringsFor(LOCALE).faqTitle, faqFor(LOCALE)) { it.faqPath }
}
